import { Observable } from 'rxjs';
import { FilterModel, PaginationModel, ProgramModel, ProgramSearchResultModel } from '../../models';

export abstract class BaseSearchService {
  public searchResults$: Observable<ProgramSearchResultModel[]>;
  public paginationResults$: Observable<PaginationModel>;

  public abstract getProgram(pathNid: string): Observable<ProgramModel>;
  public abstract queryPrograms(pagination: PaginationModel, specialties: FilterModel, dashboardProgramIds?: string[], showAci?: boolean): Observable<ProgramSearchResultModel[]>;
  public abstract queryAciPrograms(pagination: PaginationModel, specialties: FilterModel, dashboardProgramIds?: string[]): Observable<ProgramSearchResultModel[]>;
  public abstract queryMapPrograms(pagination: PaginationModel, specialties: FilterModel, dashboardProgramIds?: string[]): Observable<ProgramSearchResultModel[]>;
  public abstract getProgramsForMap(specialtyIds: string[], filters: FilterModel): Observable<ProgramSearchResultModel[]>;
  public abstract filterResults(filters: any, programs?: ProgramSearchResultModel[]): Observable<ProgramSearchResultModel[]>;
  public abstract updateSearchResults(results: ProgramSearchResultModel[], pagination?: PaginationModel): Observable<ProgramSearchResultModel[]>;
  public abstract getSubRequestProgram(programID: string): Observable<any>;
}
